
















































































import ContentTop from '@/components/accumulation/ContentTop.vue';
import {Vue, Component, Watch} from 'vue-property-decorator';
import {State} from 'vuex-class';
import {Mall, GetAccumulationsPaymentsRequest, ManageStatuses, GetAccumulationsPaymentsContent, getAccumulationsPaymentsValidation} from 'supporter';
import {MallsArrItem} from '@/types';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import FormButton from '@/components/common/FormButton.vue';
import PageTitle from '@/components/common/PageTitle.vue';

import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import {i18nInObjectList} from '@/utils/i18n';
import {ncpPopup} from '@/utils/commonUtils';
import {getToday, addMonth} from '@/utils/dateUtils';
import ItemTable from '@/components/common/ItemTable.vue';
import TuiGrid from 'tui-grid';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';

@Component({
  components: {
    ExcelCreateButton,
    top: ContentTop,
    PageTitle,
    CompSelectBox,
    CompRadioButton,
    FormButton,
    PeriodDateCalendar,
    ItemTable
  }
})
export default class AccumulationComponent extends Vue {
  @State private view!: object;

  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];

  //////////////////////////////////////
  @Watch('statusArry.length', {immediate: false, deep: false})
  length(next: number) {
    this.checkAllCheck(next);
  }
  @Watch('searchForm.params.periodType')
  onPeriodTypeChanged() {
    if (this.searchForm.params.periodType === 'REQUEST') {
      (this.$refs.dateCalendar as any).calendarInfo.endPeriod = true;
    } else {
      (this.$refs.dateCalendar as any).calendarInfo.endPeriod = false;
    }
    let periodType = (this.$refs.dateCalendar as any).calendarInfo.period;
    (this.$refs.dateCalendar as any).clickPeriod(periodType);
  }
  ////////////////////////////////////////////////
  private contentBottomOption: any = {
    gridName: '',
    haveConfigBtn: false,
    haveExcelDownBtn: false,
    excelDownInfo: {
      nameDateFormat: 'YYYYMMDD_HHmmss',
      fileName: 'accumulation_payment_',
      columns: {
        no: 'ACCUMULATION_PAYMENT_FORM_HEADER_NO',
        mallNo: 'ACCUMULATION_PAYMENT_FORM_HEADER_MALLNO',
        immediately: 'ACCUMULATION_PAYMENT_FORM_HEADER_IMMEDIATELY',
        reason: 'ACCUMULATION_PAYMENT_FORM_HEADER_REASON',
        amount: 'ACCUMULATION_PAYMENT_FORM_HEADER_PAYMENT_COUNT',
        validPeriod: 'ACCUMULATION_PAYMENT_FORM_HEADER_VALID_PERIOD',
        status: 'ACCUMULATION_PAYMENT_FORM_HEADER_STATUS',
        viewDetail: 'ACCUMULATION_PAYMENT_FORM_HEADER_VIEW_DETAIL',
        requestDateTime: 'ACCUMULATION_PAYMENT_FORM_HEADER_REQUSETTIME',
        paymentDateTime: 'ACCUMULATION_PAYMENT_FORM_HEADER_PAYMENTTIME',
        registerAdminName: 'ACCUMULATION_PAYMENT_FORM_HEADER_GREISTER_ADMIN_NAME',
        registerDateTime: 'ACCUMULATION_PAYMENT_FORM_HEADER_REGISTER_DATE_TIME',
        updateAdminName: 'ACCUMULATION_PAYMENT_FORM_HEADER_UPDATE_ADMIN_NAME',
        updateDateTime: 'ACCUMULATION_PAYMENT_FORM_HEADER_UPDATE_DATE_TIME'
      },
      formatters: {
        no: (cell: any) => {
          return cell.value;
        },
        mallNo: (cell: any) => {
          return this.formateMallsName(cell.value);
        },
        immediately: (cell: any) => {
          if (cell.value === true) {
            return `${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_IMMEDIATELY_NOW')}`;
          }
          return `${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_IMMEDIATELY_NOT')}`;
        },
        reason: (cell: any) => {
          return cell.value;
        },
        amount: (cell: any) => {
          return cell.value.toLocaleString();
        },
        validPeriod: (cell: any) => {
          if (cell.row.status === 'CANCELED') {
            return '-';
          }
          if (cell.value > 0) {
            let year = Math.floor(cell.value / 12);
            let month = cell.value % 12;

            return `${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_VALIDPERIOD_1')}${year}${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_VALIDPERIOD_2')} ${month}${window.$t(
              'ACCUMULATION_PAYMENT_FORM_PAYMENT_VALIDPERIOD_3'
            )}${cell.value}${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_VALIDPERIOD_4')}`;
          } else {
            return `${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_VALIDPERIOD_5')}`;
          }
        },
        status: (cell: any) => {
          if (cell.value === 'WAITING') {
            return `${window.$t('ACCUMULATION_PAYMENT_TOP_TBODY_STATUS_WAITING')}`;
          } else if (cell.value === 'COMPLETED') {
            return `${window.$t('ACCUMULATION_PAYMENT_TOP_TBODY_STATUS_COMPLETED')}`;
          } else if (cell.value === 'CANCELED') {
            return `${window.$t('ACCUMULATION_PAYMENT_TOP_TBODY_STATUS_CANCELED')}`;
          } else if (cell.value === 'PROCESSING') {
            return `${window.$t('ACCUMULATION_PAYMENT_TOP_TBODY_STATUS_PROCESSING')}`;
          }
        },
        viewDetail: (cell: any) => {
          if (cell.row.status === 'COMPLETED') {
            return `${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_VIEW_DETAIL_VIEW')}`;
          }
          return '-';
        },
        requestDateTime: (cell: any) => {
          if (cell.row.immediately === false) {
            return cell.value;
          }
          return '-';
        },
        paymentDateTime: (cell: any) => {
          if (cell.row.status === 'COMPLETED') {
            return cell.value;
          }
          return '-';
        },
        updateAdminName: (cell: any) => {
          if (cell.value) {
            return cell.value;
          }
          return '-';
        },
        updateDateTime: (cell: any) => {
          let values = '-';
          if (cell.row.updateAdminName) {
            return cell.value;
          }
          return values;
        }
      }
    }
  };
  private totalCount: number = 0;
  private initPageSize: number = 30;
  private mallNo: number = 0;
  private allMallNo: string = '';
  private theMalls: MallsArrItem[] = [{option: 'ACCUMULATION_PAYMENT_TOP_TBODY_STATUS_ALL', value: 0}];

  private paymentContent: GetAccumulationsPaymentsContent[] = [];
  private theSearchType = [
    {option: 'ACCUMULATION_PAYMENT_TOP_TBODY_SEARCH_TYPE_ALL', value: 'ALL'},
    {option: 'ACCUMULATION_PAYMENT_TOP_TBODY_SEARCH_TYPE_REASON', value: 'REASON'},
    {option: 'ACCUMULATION_PAYMENT_TOP_TBODY_SEARCH_TYPE_REGISTER', value: 'REGISTER'},
    {option: 'ACCUMULATION_PAYMENT_TOP_TBODY_SEARCH_TYPE_UPDATER', value: 'UPDATER'},
    {option: 'ACCUMULATION_PAYMENT_TOP_TBODY_SEARCH_TYPE_PAYMENT_NO', value: 'PAYMENT_NO'}
  ];
  private thePeriodType = [
    {option: 'ACCUMULATION_PAYMENT_TOP_TBODY_PERIOD_TYPE_REGISTER', value: 'REGISTER'},
    {option: 'ACCUMULATION_PAYMENT_TOP_TBODY_PERIOD_TYPE_PAYMENT', value: 'PAYMENT'},
    {option: 'ACCUMULATION_PAYMENT_TOP_TBODY_PERIOD_TYPE_REQUEST', value: 'REQUEST'},
    {option: 'ACCUMULATION_PAYMENT_TOP_TBODY_PERIOD_TYPE_UPDATE', value: 'UPDATE'}
  ];
  private setStatus = [
    {option: 'ACCUMULATION_PAYMENT_TOP_TBODY_SET_STATUS_ALL', value: 'ALL'},
    {option: 'ACCUMULATION_PAYMENT_TOP_TBODY_SET_STATUS_STATUS', value: 'STATUS'},
    {option: 'ACCUMULATION_PAYMENT_TOP_TBODY_SET_STATUS_IMMEDIATELY', value: 'IMMEDIATELY'}
  ];
  private statusValue: string = 'ALL';
  private statusArry: ManageStatuses[] = ['WAITING', 'COMPLETED', 'CANCELED'];
  private initStatusArry: ManageStatuses[] = ['WAITING', 'COMPLETED', 'CANCELED'];

  private startYmdt: string = addMonth(new Date(), -1);
  private endYmdt: string = getToday();
  private periodOption = {
    period: '1m'
  };
  private disabledMallSelect: boolean = false;

  // ====== For grid ========
  private gridProps = {
    options: {
      header: {
        height: 33,
        bacground: '#ccc'
      },
      columnOptions: {
        minWidth: 50
      },
      displayRowCount: 30,
      isInitialRequest: true,
      keyColumnName: 'no',
      useClientSort: false,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    keyColumnName: 'no',
    columnOptions: {
      useFormattedValue: true
    },
    showDummyRows: true,
    columns: [
      {
        header: 'ACCUMULATION_PAYMENT_FORM_HEADER_NO',
        name: 'no',
        align: 'center',
        minWidth: 52,
        resizable: true,
        copyOptions: {
          useFormattedValue: true,
          customValue: function (value: any): any {
            return value;
          }
        },
        formatter: (data: any) => {
          return `<a href="javascript:window.location.href=\'\./payment/request?mode=modify&requestNo=${data.value}&mallNo=${data.row.mallNo}\'" class='view' id="payment_no">${data.value}</a>`;
        }
      },
      {
        header: 'ACCUMULATION_PAYMENT_FORM_HEADER_MALLNO',
        name: 'mallNo',
        minWidth: 62,
        align: 'center',
        resizable: true,
        formatter: (data: any) => {
          return `${this.formateMallsName(data.value)}`;
        }
      },
      {
        header: 'ACCUMULATION_PAYMENT_FORM_HEADER_IMMEDIATELY',
        name: 'immediately',
        align: 'center',
        minWidth: 97,
        resizable: true,
        formatter: (data: any) => {
          if (data.value === true) {
            return `${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_IMMEDIATELY_NOW')}`;
          }
          return `${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_IMMEDIATELY_NOT')}`;
        }
      },
      {
        header: 'ACCUMULATION_PAYMENT_FORM_HEADER_REASON',
        name: 'reason',
        align: 'left',
        minWidth: 212,
        resizable: true,
        formatter: function (data: any) {
          if (data.row.immediately === false && data.row.status === 'WAITING') {
            return `<div class="uio_bx"><span class="tag">${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_REASON_TAG')}</span> ${data.value}</div>`;
          }

          return data.value;
        }
      },
      {
        header: 'ACCUMULATION_PAYMENT_FORM_HEADER_PAYMENT_COUNT',
        name: 'amount',
        align: 'center',
        minWidth: 97,
        resizable: true,
        formatter: function (data: any) {
          return data.value.toLocaleString();
        }
      },
      {
        header: 'ACCUMULATION_PAYMENT_FORM_HEADER_VALID_PERIOD',
        name: 'validPeriod',
        align: 'center',
        minWidth: 142,
        resizable: true,
        formatter(data: any) {
          if (data.row.status === 'CANCELED') {
            return '-';
          }

          if (data.value > 0) {
            let year = Math.floor(data.value / 12);
            let month = data.value % 12;

            return `${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_VALIDPERIOD_1')}${year}${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_VALIDPERIOD_2')} ${month}${window.$t(
              'ACCUMULATION_PAYMENT_FORM_PAYMENT_VALIDPERIOD_3'
            )}${data.value}${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_VALIDPERIOD_4')}`;
          } else {
            return `${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_VALIDPERIOD_5')}`;
          }
        }
      },
      {
        header: 'ACCUMULATION_PAYMENT_FORM_HEADER_STATUS',
        name: 'status',
        align: 'center',
        minWidth: 72,
        resizable: true,
        formatter: function (data: any) {
          if (data.value === 'WAITING') {
            return `${window.$t('ACCUMULATION_PAYMENT_TOP_TBODY_STATUS_WAITING')}`;
          } else if (data.value === 'COMPLETED') {
            return `${window.$t('ACCUMULATION_PAYMENT_TOP_TBODY_STATUS_COMPLETED')}`;
          } else if (data.value === 'CANCELED') {
            return `${window.$t('ACCUMULATION_PAYMENT_TOP_TBODY_STATUS_CANCELED')}`;
          } else if (data.value === 'PROCESSING') {
            return `${window.$t('ACCUMULATION_PAYMENT_TOP_TBODY_STATUS_PROCESSING')}`;
          }
        }
      },
      {
        header: 'ACCUMULATION_PAYMENT_FORM_HEADER_VIEW_DETAIL',
        name: 'viewDetail',
        align: 'center',
        minWidth: 72,
        resizable: true,
        formatter: function (data: any) {
          if (data.row.status === 'COMPLETED') {
            return `<a href="javascript:;" data-mall-no="${data.row.mallNo}" data-mall-name="${data.row.mallName}" data-request-no="${data.row.no}" class="view paymentView">${window.$t(
              'ACCUMULATION_PAYMENT_FORM_PAYMENT_VIEW_DETAIL_VIEW'
            )}</a>`;
          }
          return '-';
        }
      },
      {
        header: 'ACCUMULATION_PAYMENT_FORM_HEADER_REQUSETTIME',
        name: 'requestDateTime',
        align: 'center',
        minWidth: 132,
        resizable: true,
        formatter: function (data: any) {
          if (data.row.immediately === false) {
            return data.value;
          }
          return '-';
        }
      },
      {
        header: 'ACCUMULATION_PAYMENT_FORM_HEADER_PAYMENTTIME',
        name: 'paymentDateTime',
        align: 'center',
        minWidth: 132,
        resizable: true,
        formatter: function (data: any) {
          if (data.row.status === 'COMPLETED') {
            return data.value;
          }
          return '-';
        }
      },
      {
        header: 'ACCUMULATION_PAYMENT_FORM_HEADER_GREISTER_ADMIN_NAME',
        name: 'registerAdminName',
        align: 'center',
        minWidth: 97,
        resizable: true
      },
      {
        header: 'ACCUMULATION_PAYMENT_FORM_HEADER_REGISTER_DATE_TIME',
        name: 'registerDateTime',
        align: 'center',
        minWidth: 132,
        resizable: true,
        formatter: function (data: any) {
          return data.value;
        }
      },
      {
        header: 'ACCUMULATION_PAYMENT_FORM_HEADER_UPDATE_ADMIN_NAME',
        name: 'updateAdminName',
        align: 'center',
        minWidth: 97,
        resizable: true,
        formatter(data: any) {
          if (data.value) {
            return data.value;
          }
          return '-';
        }
      },
      {
        header: 'ACCUMULATION_PAYMENT_FORM_HEADER_UPDATE_DATE_TIME',
        name: 'updateDateTime',
        align: 'center',
        minWidth: 126,
        formatter(data: any) {
          let value = '-';
          if (data.row.updateAdminName) {
            return data.value;
          }
          return value;
        }
      }
    ]
  };

  private searchForm: GetAccumulationsPaymentsRequest = {
    params: {
      page: 1,
      pageSize: 30,
      mallNos: null as any,
      searchType: 'ALL',
      keyword: '',
      periodType: 'REGISTER',
      startDateTime: '2020-03-15 00:00:00',
      endDateTime: '2020-04-22 23:59:59',
      immediately: null,
      statuses: 'WAITING,COMPLETED,CANCELED' as ManageStatuses
    }
  };
  private excelDownInfo = {
    fileName: 'accumulation_payment_',
    columns: {
      no: 'ACCUMULATION_PAYMENT_FORM_HEADER_NO',
      mallNo: 'ACCUMULATION_PAYMENT_FORM_HEADER_MALLNO',
      immediately: 'ACCUMULATION_PAYMENT_FORM_HEADER_IMMEDIATELY',
      reason: 'ACCUMULATION_PAYMENT_FORM_HEADER_REASON',
      amount: 'ACCUMULATION_PAYMENT_FORM_HEADER_PAYMENT_COUNT',
      validPeriod: 'ACCUMULATION_PAYMENT_FORM_HEADER_VALID_PERIOD',
      status: 'ACCUMULATION_PAYMENT_FORM_HEADER_STATUS',
      viewDetail: 'ACCUMULATION_PAYMENT_FORM_HEADER_VIEW_DETAIL',
      requestDateTime: 'ACCUMULATION_PAYMENT_FORM_HEADER_REQUSETTIME',
      paymentDateTime: 'ACCUMULATION_PAYMENT_FORM_HEADER_PAYMENTTIME',
      registerAdminName: 'ACCUMULATION_PAYMENT_FORM_HEADER_GREISTER_ADMIN_NAME',
      registerDateTime: 'ACCUMULATION_PAYMENT_FORM_HEADER_REGISTER_DATE_TIME',
      updateAdminName: 'ACCUMULATION_PAYMENT_FORM_HEADER_UPDATE_ADMIN_NAME',
      updateDateTime: 'ACCUMULATION_PAYMENT_FORM_HEADER_UPDATE_DATE_TIME'
    },
    formatters: {
      no: (cell: any) => {
        return cell.value;
      },
      mallNo: (cell: any) => {
        return this.formateMallsName(cell.value);
      },
      immediately: (cell: any) => {
        if (cell.value === true) {
          return `${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_IMMEDIATELY_NOW')}`;
        }
        return `${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_IMMEDIATELY_NOT')}`;
      },
      reason: (cell: any) => {
        return cell.value;
      },
      amount: (cell: any) => {
        return cell.value.toLocaleString();
      },
      validPeriod: (cell: any) => {
        if (cell.row.status === 'CANCELED') {
          return '-';
        }
        if (cell.value > 0) {
          let year = Math.floor(cell.value / 12);
          let month = cell.value % 12;

          return `${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_VALIDPERIOD_1')}${year}${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_VALIDPERIOD_2')} ${month}${window.$t(
            'ACCUMULATION_PAYMENT_FORM_PAYMENT_VALIDPERIOD_3'
          )}${cell.value}${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_VALIDPERIOD_4')}`;
        } else {
          return `${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_VALIDPERIOD_5')}`;
        }
      },
      status: (cell: any) => {
        if (cell.value === 'WAITING') {
          return `${window.$t('ACCUMULATION_PAYMENT_TOP_TBODY_STATUS_WAITING')}`;
        } else if (cell.value === 'COMPLETED') {
          return `${window.$t('ACCUMULATION_PAYMENT_TOP_TBODY_STATUS_COMPLETED')}`;
        } else if (cell.value === 'CANCELED') {
          return `${window.$t('ACCUMULATION_PAYMENT_TOP_TBODY_STATUS_CANCELED')}`;
        } else if (cell.value === 'PROCESSING') {
          return `${window.$t('ACCUMULATION_PAYMENT_TOP_TBODY_STATUS_PROCESSING')}`;
        }
      },
      viewDetail: (cell: any) => {
        if (cell.row.status === 'COMPLETED') {
          return `${window.$t('ACCUMULATION_PAYMENT_FORM_PAYMENT_VIEW_DETAIL_VIEW')}`;
        }
        return '-';
      },
      requestDateTime: (cell: any) => {
        if (cell.row.immediately === false) {
          return cell.value;
        }
        return '-';
      },
      paymentDateTime: (cell: any) => {
        if (cell.row.status === 'COMPLETED') {
          return cell.value;
        }
        return '-';
      },
      updateAdminName: (cell: any) => {
        if (cell.value) {
          return cell.value;
        }
        return '-';
      },
      updateDateTime: (cell: any) => {
        let values = '-';
        if (cell.row.updateAdminName) {
          return cell.value;
        }
        return values;
      }
    }
  };

  private showStatusCheckBox: boolean = false;
  private checkAll: boolean = true;
  private size: number = 30;

  private handleSearchPayment(): void {
    this.searchPayment(1, this.size);
  }

  private GoToRequest(): void {
    this.$router.push('/accumulation/payment/request');
  }
  private formateMallsName(e: number) {
    // 之后换成this.theMalls
    let theItem = this.theMalls.filter((item) => item.value === e);
    if (theItem.length > 0) {
      return theItem[0].option;
    }
    return '';
  }
  private setTheStatus(): void {
    if (this.statusValue === 'ALL') {
      this.searchForm.params.immediately = null;
      this.showStatusCheckBox = false;
    } else if (this.statusValue === 'STATUS') {
      this.showStatusCheckBox = true;
      this.searchForm.params.immediately = false;
    } else if (this.statusValue === 'IMMEDIATELY') {
      this.searchForm.params.immediately = true;
      this.showStatusCheckBox = false;
    }
  }
  private handleCheckAll(): void {
    if (this.checkAll) {
      this.statusArry = [];
      this.statusArry = [...this.initStatusArry];
    } else {
      this.statusArry = [];
    }
  }
  private checkAllCheck(e: number): void {
    if (e === 3) {
      this.checkAll = true;
    } else {
      this.checkAll = false;
    }
  }
  private created(): void {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
    let noData = this.$t('ACCUMULATION_PAYMENT_NO_DATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    this.getTheMalls();
  }
  private mounted(): void {
    let _this = this;
    window.onresize = function () {
      _this.handleHeaderLine();
    };
    $('body').on('click', '.paymentView', $.proxy(this.onClickView, this));
  }
  private destoryed(): void {
    $('body').off('click', '.paymentView', $.proxy(this.onClickView, this));
  }
  private onClickView(e: any): void {
    const requestNo = $(e.target).data('request-no');
    const mallNo = $(e.target).data('mall-no');
    const mallName = $(e.target).data('mall-name');
    ncpPopup(`/accumulation/popup/paymentList?mallNo=${mallNo}&requestNo=${requestNo}&mallName=${mallName}`, 'ACCUMULATION_PAYMENT_POPUP_TITLE', 1000, 700);
  }
  private handleHeaderLine(): void {
    let tuiGridHeader = document.getElementsByClassName('tui-grid-cell tui-grid-cell-header');
    tuiGridHeader[0].innerHTML = `${this.$t('ACCUMULATION_PAYMENT_FORM_HEADER_NO_NEXT_LINE_1')}<br>${this.$t('ACCUMULATION_PAYMENT_FORM_HEADER_NO_NEXT_LINE_2')}`;
  }
  private getTheMalls() {
    let resArr = this.malls.map((item) => {
      return {option: item.mallName, value: item.mallNo};
    });
    this.theMalls = [{option: 'ACCUMULATION_PAYMENT_TOP_TBODY_STATUS_ALL', value: 0}, ...resArr];
    let mallNoArr: any[] = this.malls.map((item) => {
      return item.mallNo;
    });
    this.allMallNo = mallNoArr.join(',');
    if (this.malls.length === 1) {
      this.mallNo = this.malls[0].mallNo;
      this.disabledMallSelect = true;
    }
  }
  private resetSearchForm(): void {
    (this.$refs.dateCalendar as any).clickPeriod('1m');
    this.searchForm = {
      params: {
        page: 1,
        pageSize: 30,
        mallNos: null as any,
        searchType: 'ALL',
        keyword: '',
        periodType: 'REGISTER',
        startDateTime: '',
        endDateTime: '',
        immediately: null,
        statuses: 'WAITING,COMPLETED,CANCELED' as ManageStatuses
      }
    };
    this.mallNo = 0;
    this.statusValue = 'ALL';
    this.statusArry = [];
    this.statusArry = [...this.initStatusArry];
    this.showStatusCheckBox = false;
  }

  private searchPayment(page: number = 1, size?: number): void {
    if (size) {
      this.size = size;
    }
    let theStatuses = this.statusArry.join(',');
    this.searchForm.params.statuses = theStatuses as ManageStatuses;
    this.searchForm.params.startDateTime = this.startYmdt;
    this.searchForm.params.endDateTime = this.endYmdt;
    this.searchForm.params.page = page;
    this.searchForm.params.pageSize = this.size;
    if (this.mallNo === 0) {
      this.searchForm.params.mallNos = this.allMallNo;
    } else {
      this.searchForm.params.mallNos = this.mallNo as any;
    }
    let validation: any = getAccumulationsPaymentsValidation(this.searchForm);
    if (validation.length > 0) {
      alert(this.$t(validation[0].message));
      return;
    }
    this.searchForm.params.startDateTime = this.startYmdt + ' 00:00:00';
    this.searchForm.params.endDateTime = this.endYmdt + ' 23:59:59';
    $('#loading').show();
    this.$api
      .getAccumulationsPayments(this.searchForm)
      .then((res) => {
        this.paymentContent = res.data.contents;
        this.totalCount = res.data.totalCount;
        this.gridProps.options.pageOptions.page = page;
        this.gridProps.options.pageOptions.perPage = this.size;
        this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      })
      .finally(() => {
        $('#loading').hide();
        this.$nextTick(() => {
          this.handleHeaderLine();
        });
      });
  }
}
